import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { EmailForm } from 'src/app/auth/auth-form.inteface';
import { MessageLevel } from 'src/app/interfaces';
import { FormGroupControls } from 'src/app/interfaces/form-and-field.interface';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationState } from 'src/app/notifications/notifications.state';
import { ValidationService } from 'src/app/services/validation.service';
import { DIALOG_DEFAULT_DATA } from '../dialog-default/dialog-default.component';

@Component({
  selector: 'app-dialog-invite-admin',
  templateUrl: './dialog-invite-admin.component.html',
  styleUrls: ['./dialog-invite-admin.component.scss'],
})
export class DialogInviteAdminComponent extends NotificationState {
  protected notificationLevel: MessageLevel = 'INFO';

  public confirmActionButton: string = DialogActionTypes.CONFIRM_ACTION;

  private validationService = inject(ValidationService);

  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);
  public readonly modalArguments = inject(DIALOG_DEFAULT_DATA);
  public readonly form: FormGroupControls<EmailForm> = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: this.validationService.getValidators('email'),
    }),
  });

  public constructor() {
    super();

    this.validationService.setMaxInputLength(this.form, 'email');
  }

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    this.confirmAction();
  }

  public getErrorDescriptionId(type: string): string {
    return this.validationService.getErrorDescriptionId(type);
  }

  public override confirmAction(): void {
    this.activeModal.close(this.form.value.email);
  }

  public isEmailValid(): boolean {
    return this.validationService.isFieldInvalid(this.form, 'email');
  }

  public get isFormValid(): boolean {
    return this.form.valid;
  }
}
